import {Nullish} from 'shared/web';

import {SaleVehiclePhotoResponseBody} from '../types/SaleVehiclePhotoResponseBody';
import {SlideImage} from '../types/SlideImage';

export function toSlideImages(photos: SaleVehiclePhotoResponseBody[] | Nullish): SlideImage[] {
  return (
    photos?.map(
      (photo): SlideImage => ({
        type: 'image',
        id: photo.id,
        url: photo.url.replace('/resize/', '/get/'),
        resizeUrl: photo.url,
        fileName: photo.id,
      })
    ) ?? []
  );
}
